export default './icudt74l.dat';